// GENERATED by scripts/build-icons.mjs from icons/trash-2.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Trash2 = createIcon('trash-2', [
  ['path', { d: "M10 11v6" }],
  ['path', { d: "M14 11v6" }],
  ['path', { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
  ['path', { d: "M3 6h18" }],
  ['path', { d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }],
])
